import React from 'react'
import { Image } from '../../../../../../utils/image'
import { mediaBlockNestedClasses } from '../../../../../../utils/style'
import { getClassName } from '../../../../../../utils/utils'
import { MediaBlockNested } from '../../../blocksState'
import { Video } from '../../../../../components/video'
import { useInView } from '../../../../../hooks/useInView'

export type MediaBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  figureClassName: string
  figureImageClassName: string
  figureVideoClassName: string
  mediaClassName: string
  imageClassName: string
  pictureClassName: string
  videoClassName: string
  figCaptionClassName: string
  captionClassName: string
  sourceClassName: string
  cookiesClassName: string
  cookiesInnerClassName: string
  cookiesTextClassName: string
  cookiesClickableClassName: string
}>

export const MediaBlockNestedLayout = (
  props: MediaBlockNested & {
    videoCookieAccepted: boolean
    acceptVideoCookie: () => void
  }
) => {
  const { inview, index, items, videoCookieAccepted, acceptVideoCookie } = props
  const classes = mediaBlockNestedClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("MediaBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-3')}>
        {items.length > 0 && (
          <div className={getClassName(classes, 'contentClassName', 'content')}>
            {items.map((item, i) => {
              return (
                <figure
                  key={`media-${index}-${i}`}
                  className={`${getClassName(classes, 'figureClassName', 'mb-0')} ${getClassName(
                    classes,
                    item.kind === 'image' ? 'figureImageClassName' : 'figureVideoClassName',
                    ''
                  )}`}
                >
                  {item.kind === 'image'
                    ? item.image && (
                      <div className={getClassName(classes, 'mediaClassName', '')}>
                        <Image
                          {...item.image}
                          classNames={{
                            image: getClassName(classes, 'imageClassName', 'w-100'),
                            picture: getClassName(classes, 'pictureClassName', ''),
                          }}
                        />
                      </div>
                    )
                    : item.kind === 'video' &&
                    item.video !== undefined && (
                      <Video
                        url={item?.video?.url}
                        videoCookieAccepted={videoCookieAccepted}
                        acceptVideoCookie={acceptVideoCookie}
                        className="figure__video"
                      />
                    )}

                  {(item.caption || item.source) && (
                    <figcaption className={getClassName(classes, 'figCaptionClassName', 'mt-2')}>
                      {item.caption && (
                        <p className={getClassName(classes, 'captionClassName', 'small text-secondary text-center m-0')}>
                          {item.caption}
                        </p>
                      )}
                      {item.source && (
                        <p className={getClassName(classes, 'sourceClassName', 'small text-secondary text-center m-0')}>
                          {item.source}
                        </p>
                      )}
                    </figcaption>
                  )}
                </figure>
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
